var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feature-flag',{attrs:{"name":"enable-new-appointments-table"},scopedSlots:_vm._u([{key:"enabled",fn:function(){return [_c('appointments-page-v-2')]},proxy:true},{key:"disabled",fn:function(){return [_c('appointments-page-v-1')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }